interface StatPercentageProps {
  fallbackValue?: string;
  precision?: number;
  total: number | null;
  value: number | null;
}

export const getStatPercentage = ({
  value,
  total,
  precision = 1,
  fallbackValue = "0.0%",
}: StatPercentageProps) => {
  if (!value || !total) {
    return fallbackValue;
  }

  if (total > 0 && value >= 0) {
    return `${((value / total) * 100).toFixed(precision)}%`;
  }

  return fallbackValue;
};
